import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// Business FY runs 01 Jul - 30 Jun. "FY27" = 01 Jul 2026 - 30 Jun 2027.
const _currentFYEnd = (() => {
  const now = new Date();
  return now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear();
})();

export const FY_OPTIONS = (() => {
  const opts = [];
  for (let y = _currentFYEnd - 3; y <= _currentFYEnd + 1; y++) {
    opts.push(`FY${String(y).slice(2)}`);
  }
  return opts;
})();

export const FiscalYearSelect = ({ value, onChange, testId = 'fiscal-year-filter' }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-32" data-testid={testId}>
      <SelectValue placeholder="Fiscal Year" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">All FYs</SelectItem>
      {FY_OPTIONS.map(fy => (
        <SelectItem key={fy} value={fy}>{fy}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default FiscalYearSelect;
